const { wrapItems } = require('./helpers');

module.exports = ({ items = [], reduced = [], added = [], added_reduced = [], added_charges = [] }) => {

  const output = { total: 0 };

  for(let item of wrapItems(items)){

    if(!output[item.tva.toString()]){
      output[item.tva.toString()] = 0;
    }

    let value = item.getFullValue();

    output[item.tva.toString()] += value;
    output.total += value;

  }

  for(let item of wrapItems(reduced)){

    if(!output[item.tva.toString()]){
      output[item.tva.toString()] = 0;
    }

    let value = item.getReducedValue();

    output[item.tva.toString()] += value;
    output.total += value;

  }

  for(let item of wrapItems(added)){

    if(!output[item.tva.toString()]){
      output[item.tva.toString()] = 0;
    }

    let value = item.getFullValue();

    output[item.tva.toString()] += value;
    output.total += value;

  }

  for(let item of wrapItems(added_reduced)){

    if(!output[item.tva.toString()]){
      output[item.tva.toString()] = 0;
    }

    let value = item.getReducedValue();

    output[item.tva.toString()] += value;
    output.total += value;

  }

  for(let item of added_charges){

    if(!output[item.tva.toString()]){
      output[item.tva.toString()] = 0;
    }

    let value = item.amount;

    output[item.tva.toString()] += value;
    output.total += value;

  }

  return output;
};